import React, { useEffect, useState } from 'react'
import {
	Box,
	Button,
	Card,
	CardContent,
	FormControl,
	TextField,
	Typography,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useLoginMutation } from '../../store/api/vacanciesApi'
import StorageService, { StorageKeys } from '../../services/StorageService'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { setIsAuth } from '../../store/slice/appSlice'
import { useHandleError } from '../../hooks/useHandleError'

const LoginCard = () => {
	const navigate = useNavigate()
	const [login, { data, isSuccess, isLoading, error }] = useLoginMutation()
	const errorMessage = useHandleError(error)
	const [isShowError, setIsShowError] = useState(false)
	const dispatch = useAppDispatch()

	const [username, setUsername] = useState('')
	const [password, setPassword] = useState('')

	useEffect(() => {
		if (!isLoading && isSuccess && data) {
			StorageService.setItem(StorageKeys.access_token, data.access)
			StorageService.setItem(StorageKeys.refresh_token, data.refresh)
			StorageService.setItem(StorageKeys.name, username)
			dispatch(setIsAuth())
			navigate('/vacancies')
		}
	}, [isLoading])

	useEffect(() => {
		if (errorMessage) {
			setIsShowError(true)
		}
	}, [errorMessage])

	useEffect(() => {
		if (isShowError) {
			setIsShowError(false)
		}
	}, [password, username])

	const handleSubmit = () => {
		login({
			username,
			password,
		})
	}

	return (
		<Card variant="outlined">
			<CardContent sx={{ minWidth: '400px' }}>
				<Typography
					component="h1"
					variant="h4"
					sx={{ width: '100%' }}
					mb={'12px'}
					align="center"
				>
					Вхід
				</Typography>
				<Box
					component="form"
					//onSubmit={handleSubmit}
					//noValidate
					sx={{
						display: 'flex',
						flexDirection: 'column',
						width: '100%',
						gap: 2,
					}}
				>
					<FormControl>
						<TextField
							error={isShowError}
							//helperText={emailErrorMessage}
							name="username"
							label="Ім'я"
							placeholder="username"
							autoComplete="email"
							autoFocus
							required
							fullWidth
							variant="outlined"
							value={username}
							onChange={(e) => setUsername(e.target.value)}
							color={isShowError ? 'error' : 'primary'}
						/>
					</FormControl>
					<FormControl>
						<TextField
							label="Пароль"
							error={isShowError}
							helperText={isShowError ? errorMessage : undefined}
							name="password"
							placeholder="••••••"
							type="password"
							id="password"
							autoComplete="current-password"
							autoFocus
							required
							fullWidth
							variant="outlined"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							color={isShowError ? 'error' : 'primary'}
						/>
					</FormControl>
					{/*<FormControlLabel
						control={<Checkbox value="remember" color="primary" />}
						label="Remember me"
					/>*/}
					<Button
						loading={isLoading}
						type="submit"
						fullWidth
						variant="contained"
						onClick={handleSubmit}
					>
						Увійти
					</Button>
				</Box>
			</CardContent>
		</Card>
	)
}

export default LoginCard
